import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiExternalFakeGateway } from '@/data/fake/api-external-fake.gateway';
import { ApiExternalInvitationFakeGateway } from '@/data/fake/api-external-invitation-fake.gateway';
import { ApiImpactCalculateFestivalFakeGateway } from '@/data/fake/api-impact-calculate-festival-fake.gateway';
import { ApiImpactCalculateTourFakeGateway } from '@/data/fake/api-impact-calculate-tour-fake.gateway';
import { ApiImpactCalculateVenueFakeGateway } from '@/data/fake/api-impact-calculate-venue-fake.gateway';
import { ApiImpactCo2FakeGateway } from '@/data/fake/api-impact-co2-fake.gateway';
import { ApiImpactEnvFakeGateway } from '@/data/fake/api-impact-env-fake.gateway';
import { ApiImpactEssFakeGateway } from '@/data/fake/api-impact-ess-fake.gateway';
import { ApiImpactReferencesFakeGateway } from '@/data/fake/api-impact-references-fake.gateway';
import { ApiImpactStatsFakeGateway } from '@/data/fake/api-impact-stats-fake.gateway';
import { ApiOrganisationFakeGateway } from '@/data/fake/api-organisation-fake.gateway';
import { ApiProjectFestivalFakeGateway } from '@/data/fake/api-project-festival-fake.gateway';
import { ApiProjectPdfReportFakeGateway } from '@/data/fake/api-project-pdf-report-fake.gateway';
import { ApiProjectTourFakeGateway } from '@/data/fake/api-project-tour-fake.gateway';
import { ApiProjectTourOntourFakeGateway } from '@/data/fake/api-project-tour-ontour-fake.gateway';
import { ApiProjectVenueDatesFakeGateway } from '@/data/fake/api-project-venue-dates-fake.gateway';
import { ApiProjectVenueFakeGateway } from '@/data/fake/api-project-venue-fake.gateway';
import { ApiProjectVenueMonthDeclarationFakeGateway } from '@/data/fake/api-project-venue-month-declaration-fake.gateway';
import { ApiProjectVenuePresetsFakeGateway } from '@/data/fake/api-project-venue-presets-fake.gateway';
import { ApiTagsFakeGateway } from '@/data/fake/api-tags-fake.gateway';
import { AuthFakeGateway } from '@/data/fake/auth-fake.gateway';
import { ApiAuthHttpGateway } from '@/data/http/auth/api-auth-http-gateway';
import { ApiExternalHttpGateway } from '@/data/http/external/api-external-http.gateway';
import { ApiExternalInvitationHttpGateway } from '@/data/http/external-invitation/api-external-invitation-http.gateway';
import { ApiImpactCalculateFestivalHttpGateway } from '@/data/http/impact-calculate-festival/api-impact-calculate-festival-http.gateway';
import { ApiImpactCalculateTourHttpGateway } from '@/data/http/impact-calculate-tour/api-impact-calculate-tour-http.gateway';
import { ApiImpactCalculateVenueHttpGateway } from '@/data/http/impact-calculate-venue/api-impact-calculate-venue-http.gateway';
import { ApiImpactCo2HttpGateway } from '@/data/http/impact-co2/api-impact-co2-http.gateway';
import { ApiImpactEnvHttpGateway } from '@/data/http/impact-env/api-impact-env-http.gateway';
import { ApiImpactEssHttpGateway } from '@/data/http/impact-ess/api-impact-ess-http.gateway';
import { ApiImpactReferencesHttpGateway } from '@/data/http/impact-references/api-impact-references-http.gateway';
import { ApiImpactStatsHttpGateway } from '@/data/http/impact-stats/api-impact-stats-http.gateway';
import { ApiOrganisationHttpGateway } from '@/data/http/organisation/api-organisation-http.gateway';
import { ApiProjectPdfReportGateway } from '@/data/http/pdf-exports/api-project-pdf-http.gateway';
import { ApiProjectHttpGateway } from '@/data/http/project-festival/api-project-festival-http.gateway';
import { ApiProjectTourHttpGateway } from '@/data/http/project-tour/api-project-tour-http.gateway';
import { ApiProjectTourOntourHttpGateway } from '@/data/http/project-tour-ontour/api-project-tour-ontour-http.gateway';
import { ApiProjectVenueHttpGateway } from '@/data/http/project-venue/api-project-venue-http.gateway';
import { ApiProjectVenueDatesHttpGateway } from '@/data/http/project-venue-dates/api-project-venue-dates-http.gateway';
import { ApiProjectVenueMonthDeclarationHttpGateway } from '@/data/http/project-venue-month-declaration/api-project-venue-dates-http.gateway.ts';
import { ApiProjectVenuePresetsHttpGateway } from '@/data/http/project-venue-presets/api-project-venue-presets-http.gateway.ts';
import { ApiTagHttpGateway } from '@/data/http/tags/api-tag-http.gateway.ts';
import { AuthGateway } from '@/domain/auth/gateways/auth.gateway';
import { ExternalGateway } from '@/domain/external/gateway/external.gateway';
import { ExternalInvitationGateway } from '@/domain/external-invitation/gateway/external-invitation.gateway';
import { ImpactCalculateFestivalGateway } from '@/domain/impact-calculate-festival/gateways/impact-calculate-festival.gateway';
import { ImpactCalculateTourGateway } from '@/domain/impact-calculate-tour/gateways/impact-calculate-tour.gateway';
import { ImpactCalculateVenueGateway } from '@/domain/impact-calculate-venue/gateways/impact-calculate-venue.gateway';
import { ImpactCo2Gateway } from '@/domain/impact-co2/gateways/impact-co2.gateway';
import { ImpactEnvGateway } from '@/domain/impact-env/gateways/impact-env.gateway';
import { ImpactEssGateway } from '@/domain/impact-ess/gateways/impact-ess.gateway';
import { ImpactReferencesGateway } from '@/domain/impact-references/gateways/impact-references.gateway';
import { ImpactStatsGateway } from '@/domain/impact-stats/gateways/impact-stats.gateway';
import { OrganisationGateway } from '@/domain/organisation/gateways/organisation.gateway';
import { ProjectExportReportProjectGateway } from '@/domain/project/gateways/export-report-project.gateway';
import { ProjectFestivalGateway } from '@/domain/project-festival/gateways/project-festival.gateway';
import { ProjectTourGateway } from '@/domain/project-tour/gateways/project-tour.gateway';
import { ProjectVenueGateway } from '@/domain/project-venue/gateways/project-venue.gateway';
import { ProjectVenueDatesGateway } from '@/domain/project-venue-dates/gateways/project-venue-dates.gateway';
import { ProjectVenueMonthDeclarationGateway } from '@/domain/project-venue-month-declaration/gateways/project-venue-month-declaration.gateway';
import { ProjectVenuePresetsGateway } from '@/domain/project-venue-presets/gateways/project-venue-presets.gateway.ts';
import { NotistackSnackbarGateway } from '@/domain/snackbar/gateways/notistack.snackbar.gateway';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { AppDispatch, RootState } from '@/domain/store';
import { TagGateway } from '@/domain/tags/gateways/tag.gateway.ts';

import { ProjectTourOntourGateway } from './project-tour-ontour/gateways/project-tour-ontour.gateway';

export const thunkExtraArgument = createThunkExtraArgument();

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  extra: ThunksExtraArgument;
}>();

export type ThunksExtraArgument = {
  authGateway: AuthGateway;
  organisationGateway: OrganisationGateway;
  tagsGateway: TagGateway;
  projectFestivalGateway: ProjectFestivalGateway;
  projectExportReportGateway: ProjectExportReportProjectGateway;
  projectVenueGateway: ProjectVenueGateway;
  projectVenueDatesGateway: ProjectVenueDatesGateway;
  projectVenuePresetsGateway: ProjectVenuePresetsGateway;
  projectVenueMonthDeclarationGateway: ProjectVenueMonthDeclarationGateway;
  projectTourGateway: ProjectTourGateway;
  projectTourOntourGateway: ProjectTourOntourGateway;
  impactCalculateFestivalGateway: ImpactCalculateFestivalGateway;
  impactCalculateVenueGateway: ImpactCalculateVenueGateway;
  impactCalculateTourGateway: ImpactCalculateTourGateway;
  impactReferencesGateway: ImpactReferencesGateway;
  impactStatsGateway: ImpactStatsGateway;
  impactCo2Gateway: ImpactCo2Gateway;
  impactEssGateway: ImpactEssGateway;
  impactEnvGateway: ImpactEnvGateway;
  externalInvitationGateway: ExternalInvitationGateway;
  externalGateway: ExternalGateway;
  snackbarGateway: SnackbarGateway;
};

function createThunkExtraArgument(): ThunksExtraArgument {
  if (import.meta.env.VITE_ENABLE_FAKE_GATEWAY === 'true') {
    return createFakeGateway();
  }
  return createHttpGateway();
}

function createFakeGateway(): ThunksExtraArgument {
  return {
    authGateway: new AuthFakeGateway(),
    organisationGateway: new ApiOrganisationFakeGateway(),
    tagsGateway: new ApiTagsFakeGateway(),
    projectFestivalGateway: new ApiProjectFestivalFakeGateway(),
    projectExportReportGateway: new ApiProjectPdfReportFakeGateway(),
    projectVenueGateway: new ApiProjectVenueFakeGateway(),
    projectVenueDatesGateway: new ApiProjectVenueDatesFakeGateway(),
    projectVenuePresetsGateway: new ApiProjectVenuePresetsFakeGateway(),
    projectVenueMonthDeclarationGateway:
      new ApiProjectVenueMonthDeclarationFakeGateway(),
    projectTourGateway: new ApiProjectTourFakeGateway(),
    projectTourOntourGateway: new ApiProjectTourOntourFakeGateway(),
    impactCalculateFestivalGateway: new ApiImpactCalculateFestivalFakeGateway(),
    impactCalculateVenueGateway: new ApiImpactCalculateVenueFakeGateway(),
    impactCalculateTourGateway: new ApiImpactCalculateTourFakeGateway(),
    impactReferencesGateway: new ApiImpactReferencesFakeGateway(),
    impactStatsGateway: new ApiImpactStatsFakeGateway(),
    impactCo2Gateway: new ApiImpactCo2FakeGateway(),
    impactEssGateway: new ApiImpactEssFakeGateway(),
    impactEnvGateway: new ApiImpactEnvFakeGateway(),
    externalInvitationGateway: new ApiExternalInvitationFakeGateway(),
    externalGateway: new ApiExternalFakeGateway(),
    snackbarGateway: new NotistackSnackbarGateway(),
  };
}

function createHttpGateway(): ThunksExtraArgument {
  return {
    authGateway: new ApiAuthHttpGateway(),
    organisationGateway: new ApiOrganisationHttpGateway(),
    tagsGateway: new ApiTagHttpGateway(),
    projectFestivalGateway: new ApiProjectHttpGateway(),
    projectExportReportGateway: new ApiProjectPdfReportGateway(),
    projectVenueGateway: new ApiProjectVenueHttpGateway(),
    projectVenueDatesGateway: new ApiProjectVenueDatesHttpGateway(),
    projectVenuePresetsGateway: new ApiProjectVenuePresetsHttpGateway(),
    projectVenueMonthDeclarationGateway:
      new ApiProjectVenueMonthDeclarationHttpGateway(),
    projectTourGateway: new ApiProjectTourHttpGateway(),
    projectTourOntourGateway: new ApiProjectTourOntourHttpGateway(),
    impactCalculateFestivalGateway: new ApiImpactCalculateFestivalHttpGateway(),
    impactCalculateVenueGateway: new ApiImpactCalculateVenueHttpGateway(),
    impactCalculateTourGateway: new ApiImpactCalculateTourHttpGateway(),
    impactReferencesGateway: new ApiImpactReferencesHttpGateway(),
    impactStatsGateway: new ApiImpactStatsHttpGateway(),
    impactCo2Gateway: new ApiImpactCo2HttpGateway(),
    impactEssGateway: new ApiImpactEssHttpGateway(),
    impactEnvGateway: new ApiImpactEnvHttpGateway(),
    externalInvitationGateway: new ApiExternalInvitationHttpGateway(),
    externalGateway: new ApiExternalHttpGateway(),
    snackbarGateway: new NotistackSnackbarGateway(),
  };
}
